var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#E0ECFF",
    fillOpacity: 0.8,
    stroke: "#2D8CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C10 15.7002 10 14.0502 11.0251 13.0251C12.0503 12 13.7002 12 17 12H18C21.2998 12 22.9497 12 23.9749 13.0251C25 14.0502 25 15.7002 25 19V21C25 24.2998 25 25.9497 23.9749 26.9749C22.9497 28 21.2998 28 18 28H17C13.7002 28 12.0503 28 11.0251 26.9749C10 25.9497 10 24.2998 10 21V19Z",
    stroke: "#2D8CFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.9059L25.1259 16.802C27.2417 15.0562 28.2996 14.1834 29.1498 14.6048C30 15.0263 30 16.4236 30 19.2181V20.7819C30 23.5765 30 24.9737 29.1498 25.3952C28.2996 25.8166 27.2417 24.9438 25.1259 23.198L25 23.0941",
    stroke: "#2D8CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19C20.3284 19 21 18.3284 21 17.5C21 16.6716 20.3284 16 19.5 16C18.6716 16 18 16.6716 18 17.5C18 18.3284 18.6716 19 19.5 19Z",
    stroke: "#2D8CFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomsIcon);
export default __webpack_public_path__ + "static/media/roomsIcon.f98fe65b4092b7609a3889e692e859ec.svg";
export { ForwardRef as ReactComponent };